
await loadComponent('./components/mc-element.js', false);
// queste sono le uniche librerie che hanno "res" invece che "components", le ho messe qua solo per farti vedere come si importano
await loadComponent('./res/mc-utils.js', false); // la trovi documentata sulla tab McUtils nella sezione test
await loadComponent('./res/mc-events.js', false); // la trovi documentata sulla tab Eventi nella sezione test
await loadComponent('./res/mc-shopify.js', false); // la trovi documentata sulla tab McShopify nella sezione test

class ProductGalleryLightbox {
    constructor() {
        this.lightbox = null;
        this.currentImage = null;
        this.images = [];
        this.currentIndex = 0;
        this.zoomLevel = 1;
        this.isPanning = false;
        this.startX = 0;
        this.startY = 0;
        this.translateX = 0;
        this.translateY = 0;
        this.init();
    }

    init() {
        this.createLightbox();
        document.addEventListener('keydown', this.handleKeyboard.bind(this));
    }

    createLightbox() {
        this.lightbox = document.createElement('div');
        this.lightbox.className = 'product-lightbox-popup';
        this.lightbox.innerHTML = `
            <div class="lightbox-overlay"></div>
            <div class="lightbox-modal">
                <button class="lightbox-close" aria-label="Close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
                <div class="lightbox-main-container">
                    <div class="lightbox-controls-bar">
                        <button class="lightbox-nav-prev" aria-label="Previous image">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                        </button>
                        <div class="lightbox-zoom-controls">
                            <button class="zoom-out" aria-label="Zoom out">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <path d="m21 21-4.35-4.35"></path>
                                    <line x1="8" y1="11" x2="14" y2="11"></line>
                                </svg>
                            </button>
                            <span class="zoom-level">100%</span>
                            <button class="zoom-in" aria-label="Zoom in">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <path d="m21 21-4.35-4.35"></path>
                                    <line x1="11" y1="8" x2="11" y2="14"></line>
                                    <line x1="8" y1="11" x2="14" y2="11"></line>
                                </svg>
                            </button>
                            <button class="zoom-reset" aria-label="Reset zoom">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <polyline points="1 4 1 10 7 10"></polyline>
                                    <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
                                </svg>
                            </button>
                        </div>
                        <button class="lightbox-nav-next" aria-label="Next image">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </button>
                    </div>
                    <div class="lightbox-image-container">
                        <img class="lightbox-image" alt="Product image">
                    </div>
                </div>
                <div class="lightbox-thumbnails"></div>
                <div class="lightbox-counter">
                    <span class="current-index">1</span> / <span class="total-count">0</span>
                </div>
            </div>
        `;

        this.lightbox.style.display = 'none';
        document.body.appendChild(this.lightbox);

    
        this.lightbox.querySelector('.lightbox-overlay').addEventListener('click', () => this.close());
        this.lightbox.querySelector('.lightbox-close').addEventListener('click', () => this.close());
        this.lightbox.querySelector('.lightbox-nav-prev').addEventListener('click', () => this.previousImage());
        this.lightbox.querySelector('.lightbox-nav-next').addEventListener('click', () => this.nextImage());

        // Zoom controls
        this.lightbox.querySelector('.zoom-in').addEventListener('click', () => this.zoomStep(1.5));
        this.lightbox.querySelector('.zoom-out').addEventListener('click', () => this.zoomStep(0.67));
        this.lightbox.querySelector('.zoom-reset').addEventListener('click', () => this.resetZoom());

        // Setup image zoom and pan
        this.setupImageInteraction();
    }

    setupImageInteraction() {
        const imageContainer = this.lightbox.querySelector('.lightbox-image-container');
        const image = this.lightbox.querySelector('.lightbox-image');

        // Double click to zoom
        imageContainer.addEventListener('dblclick', (e) => {
            e.preventDefault();
            if (this.zoomLevel === 1) {
                this.zoomLevel = 2.5;
                const rect = imageContainer.getBoundingClientRect();
                const clickX = (e.clientX - rect.left) / rect.width - 0.5;
                const clickY = (e.clientY - rect.top) / rect.height - 0.5;
                this.translateX = -clickX * rect.width * (this.zoomLevel - 1) / 2;
                this.translateY = -clickY * rect.height * (this.zoomLevel - 1) / 2;
            } else {
                this.resetZoom();
            }
            this.applyZoom();
        });

        // Mouse wheel zoom
        imageContainer.addEventListener('wheel', (e) => {
            e.preventDefault();
            const delta = e.deltaY > 0 ? 0.9 : 1.1;
            const newScale = Math.min(Math.max(1, this.zoomLevel * delta), 5);
            
            if (newScale !== this.zoomLevel) {
                if (newScale === 1) {
                    this.resetZoom();
                } else {
                    const scaleFactor = newScale / this.zoomLevel;
                    this.zoomLevel = newScale;
                    this.translateX *= scaleFactor;
                    this.translateY *= scaleFactor;
                }
                this.applyZoom();
            }
        }, { passive: false });

        // Pan when zoomed
        image.addEventListener('mousedown', (e) => {
            if (this.zoomLevel > 1) {
                e.preventDefault();
                this.isPanning = true;
                this.startX = e.clientX - this.translateX;
                this.startY = e.clientY - this.translateY;
                image.style.cursor = 'grabbing';
            }
        });

        image.addEventListener('mousemove', (e) => {
            if (this.isPanning && this.zoomLevel > 1) {
                e.preventDefault();
                this.translateX = e.clientX - this.startX;
                this.translateY = e.clientY - this.startY;
                this.applyZoom();
            }
        });

        image.addEventListener('mouseup', () => {
            this.isPanning = false;
            const image = this.lightbox.querySelector('.lightbox-image');
            if (this.zoomLevel > 1) {
                image.style.cursor = 'grab';
            } else {
                image.style.cursor = 'zoom-in';
            }
        });

        image.addEventListener('mouseleave', () => {
            this.isPanning = false;
            if (this.zoomLevel > 1) {
                image.style.cursor = 'grab';
            } else {
                image.style.cursor = 'zoom-in';
            }
        });

        // Touch support
        let initialDistance = 0;
        let touchStartX = 0;
        let touchStartY = 0;

        imageContainer.addEventListener('touchstart', (e) => {
            if (e.touches.length === 2) {
                e.preventDefault();
                initialDistance = Math.hypot(
                    e.touches[0].clientX - e.touches[1].clientX,
                    e.touches[0].clientY - e.touches[1].clientY
                );
            } else if (e.touches.length === 1) {
                touchStartX = e.touches[0].clientX - this.translateX;
                touchStartY = e.touches[0].clientY - this.translateY;
                this.isPanning = true;
            }
        }, { passive: false });

        imageContainer.addEventListener('touchmove', (e) => {
            if (e.touches.length === 2) {
                e.preventDefault();
                const currentDistance = Math.hypot(
                    e.touches[0].clientX - e.touches[1].clientX,
                    e.touches[0].clientY - e.touches[1].clientY
                );
                
                const newScale = Math.min(Math.max(1, this.zoomLevel * (currentDistance / initialDistance)), 5);
                
                if (newScale !== this.zoomLevel) {
                    this.zoomLevel = newScale;
                    if (this.zoomLevel === 1) {
                        this.translateX = 0;
                        this.translateY = 0;
                    }
                    this.applyZoom();
                }
                
                initialDistance = currentDistance;
            } else if (e.touches.length === 1 && this.isPanning && this.zoomLevel > 1) {
                e.preventDefault();
                this.translateX = e.touches[0].clientX - touchStartX;
                this.translateY = e.touches[0].clientY - touchStartY;
                this.applyZoom();
            }
        }, { passive: false });

        imageContainer.addEventListener('touchend', () => {
            this.isPanning = false;
        });
    }

    open(images, index = 0) {
        this.images = images;
        this.currentIndex = index;
        this.lightbox.style.display = 'block';
        document.body.style.overflow = 'hidden';
        
        // Update total count
        this.lightbox.querySelector('.total-count').textContent = this.images.length;
        
        // Create thumbnails
        this.createThumbnails();
        
        // Show first image
        this.showImage(index);
        
        requestAnimationFrame(() => {
            this.lightbox.classList.add('active');
        });
    }

    createThumbnails() {
        const thumbContainer = this.lightbox.querySelector('.lightbox-thumbnails');
        thumbContainer.innerHTML = '';
        
        this.images.forEach((imageSrc, index) => {
            const thumb = document.createElement('div');
            thumb.className = 'lightbox-thumbnail';
            thumb.dataset.index = index;
            thumb.innerHTML = `<img src="${imageSrc}" alt="Thumbnail ${index + 1}">`;
            thumb.addEventListener('click', () => this.showImage(index));
            thumbContainer.appendChild(thumb);
        });
    }

    showImage(index) {
        this.currentIndex = index;
        const image = this.lightbox.querySelector('.lightbox-image');
        
        // Get high resolution URL
        let highResUrl = this.images[index];
        highResUrl = highResUrl.replace(/[?&]width=\d+/g, '');
        highResUrl = highResUrl.replace(/[?&]height=\d+/g, '');
        highResUrl = highResUrl.replace(/_\d+x\d*(\.\w+)/, '$1');
        highResUrl = highResUrl.replace(/\?&/, '?').replace(/\?$/, '');
        if (highResUrl.includes('?')) {
            highResUrl = highResUrl + '&width=2048&height=2048';
        } else {
            highResUrl = highResUrl + '?width=2048&height=2048';
        }
        
        image.src = highResUrl;
        
        // Update counter
        this.lightbox.querySelector('.current-index').textContent = index + 1;
        
        // Update thumbnail active state
        const thumbnails = this.lightbox.querySelectorAll('.lightbox-thumbnail');
        thumbnails.forEach((thumb, i) => {
            thumb.classList.toggle('active', i === index);
        });
        
        // Reset zoom when changing images
        this.resetZoom();
    }

    previousImage() {
        this.showImage((this.currentIndex - 1 + this.images.length) % this.images.length);
    }

    nextImage() {
        this.showImage((this.currentIndex + 1) % this.images.length);
    }

    close() {
        this.lightbox.classList.remove('active');
        document.body.style.overflow = '';
        
        setTimeout(() => {
            this.lightbox.style.display = 'none';
            this.resetZoom();
        }, 300);
    }

    applyZoom() {
        const image = this.lightbox.querySelector('.lightbox-image');
        image.style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.zoomLevel})`;
        
        // Update zoom level display
        this.updateZoomLevel();
        
        // Update cursor
        if (this.zoomLevel > 1) {
            image.style.cursor = 'grab';
        } else {
            image.style.cursor = 'zoom-in';
        }
    }

    updateZoomLevel() {
        const zoomLevelElement = this.lightbox.querySelector('.zoom-level');
        if (zoomLevelElement) {
            zoomLevelElement.textContent = `${Math.round(this.zoomLevel * 100)}%`;
        }
    }

    zoomStep(factor) {
        this.zoomLevel = Math.min(Math.max(1, this.zoomLevel * factor), 5);
        if (this.zoomLevel === 1) {
            this.translateX = 0;
            this.translateY = 0;
        }
        this.applyZoom();
    }

    resetZoom() {
        this.zoomLevel = 1;
        this.translateX = 0;
        this.translateY = 0;
        this.applyZoom();
    }

    handleKeyboard(e) {
        if (this.lightbox.style.display === 'none') return;

        switch(e.key) {
            case 'Escape':
                this.close();
                break;
            case 'ArrowLeft':
                this.previousImage();
                break;
            case 'ArrowRight':
                this.nextImage();
                break;
            case '+':
            case '=':
                this.zoomStep(1.5);
                break;
            case '-':
                this.zoomStep(0.67);
                break;
            case '0':
                this.resetZoom();
                break;
        }
    }
}

// Create global instance
if (!window.productGalleryLightbox) {
    window.productGalleryLightbox = new ProductGalleryLightbox();
}



// ExampleComponent è un componente custom che estende McElement, McElement estende HTMLElement e fornisce funzionalità aggiuntive per la creazione di componenti web personalizzati.
class ProductGallery extends McElement {

    connectedCallback() {
        this.cmpLoad();
        this.mobile();
    }

    cmpLoad() {

        const toggleButton = this.querySelector('.toggle-autoplay');
        const swiperElement = this.querySelector('.swiper');

        
        if (!toggleButton || !swiperElement) {
            console.error('Elementi .toggle-autoplay o .swiper non trovati dentro a', this);
            return;
        }

        
        toggleButton.addEventListener('click', () => { // Uso una arrow function per mantenere il contesto di 'this'

            
            const swiperInstance = swiperElement.swiper;

            console.log('Tasto cliccato, istanza swiper:', swiperInstance.autoplay);

            if (swiperInstance && swiperInstance.autoplay) {
                if (swiperInstance.autoplay.running) {
                    // Ferma immediatamente qualsiasi transizione in corso
                    swiperInstance.setTransition(0);
                    swiperInstance.slideToClosest(0);
                    // Stop autoplay
                    swiperInstance.autoplay.stop();
                    swiperInstance.autoplay.paused = true;
                    toggleButton.innerHTML = '&#9654;'; // Icona Play
                } else {
                    // Start immediato
                    swiperInstance.autoplay.start();
                    swiperInstance.autoplay.paused = false;
                    toggleButton.innerHTML = '||'; // Icona Pausa
                }
            }

        });


        /*
        <div class="swiper-slide">
                {% render 'image', image: image , class: 'w-100 max-image-height slide-zoom' %}
              </div>
         */

        const imgs = this.querySelectorAll('.swiper-slide');
        let currentIndex = 0; // Aggiungi una variabile per tracciare l'indice corrente

        imgs.forEach((img, index) => {
            img.addEventListener('click', () => {
                // Collect all images
                const allImages = [];
                imgs.forEach((slideImg) => {
                    const imgElement = slideImg.querySelector('img');
                    if (imgElement) {
                        allImages.push(imgElement.src);
                    }
                });
                
                // Open lightbox with all images at current index
                if (window.productGalleryLightbox) {
                    window.productGalleryLightbox.open(allImages, index);
                }
            });
        });
        
        // Aggiungi zoom anche per le immagini nella image-gallery
        const galleryImages = document.querySelectorAll('.gallery-image-zoom');
        galleryImages.forEach((galleryItem, index) => {
            galleryItem.addEventListener('click', function() {
                // Collect all product images
                const allProductImages = [];
                const allImgElements = document.querySelectorAll('.swiper-slide img, .gallery-image-zoom img, .image-gallery img');
                allImgElements.forEach((img) => {
                    if (img.src) {
                        allProductImages.push(img.src);
                    }
                });
                
                // Find current index
                const imgToZoom = galleryItem.querySelector('img') || galleryItem;
                let currentGalleryIndex = parseInt(galleryItem.dataset.index || index);
                
           
                if (window.productGalleryLightbox && allProductImages.length > 0) {
                    window.productGalleryLightbox.open(allProductImages, currentGalleryIndex);
                }
            });
        });

    }



    // metodi aggiuntivi del componente, richiamabili anche da altri
    mobile = () => {
        // qui possiamo fare quello che vogliamo, ad esempio accedere agli attributi del componente

        if(this.dataset.text=='mobile') {
            console.log("componente mobile");

            const toggleButton = this.querySelector('.toggle-autoplay');
            const swiperElement = this.querySelector('.swiper');

            toggleButton?.remove(); // Rimuovo il bottone se il dataset.text è 'stopp'

            setTimeout(() => {
                const swiperInstance = swiperElement.swiper;
                //swiperInstance.autoplay.stop(); // Ferma l'autoplay
                swiperInstance.autoplay.paused = true; // Imposto lo stato di pausa
                swiperInstance.init();
            }
            , 2000); // Attendo 2 secondo prima di fermare l'autoplay


        }

        console.log("L'attributo data-text contiene:", this.dataset.text);
    }
}
// il nome del componente deve essere in kebab-case, e deve essere unico, altrimenti non funzionerà
if (!customElements.get('product-gallery')) {
    // registriamo il componente, se non è già stato registrato
    customElements.define('product-gallery', ProductGallery);
}
window.ProductGallery = ProductGallery; // rendiamo il componente accessibile globalmente
